import forEach from 'lodash/forEach';
import get from 'lodash/get';
import keyBy from 'lodash/keyBy';

import { caseLogicMsg, dialogueMsg } from '../validationMessages';

function validateAiNodes(caseConf, nodeInfo) {
  const aiQuestions = get(caseConf, 'dialogue.aiQuestions', []);
  const aiUnsolicited = get(caseConf, 'dialogue.aiUnsolicited', []);
  const questionsById = keyBy(aiQuestions, 'id');
  const unsolicitedById = keyBy(aiUnsolicited, 'id');

  const errors = [];
  const warnings = [];

  // Action nodes
  const aiActionTypes = ['AI_QUESTION'];

  nodeInfo.actionNodes.forEach((node) => {
    const action = get(node, 'data.action');
    if (action && aiActionTypes.includes(action.type)) {
      if (!action.id) {
        errors.push(caseLogicMsg('You need to select a question', node.id));
      } else if (!questionsById[action.id]) {
        errors.push(caseLogicMsg('Question could not be found', node.id));
      } else if (!action.confidence) {
        errors.push(caseLogicMsg('You need to set confidence', node.id));
      }
    }
  });

  // Check nodes
  const aiCheckTypes = ['AI_QUESTION'];

  nodeInfo.checkNodes.forEach((node) => {
    forEach(node.data, (check, checkKey) => {
      if (aiCheckTypes.includes(check.type)) {
        if (!check.id) {
          errors.push(caseLogicMsg('You need to select a question', node.id, { checkKey }));
        } else if (!questionsById[check.id]) {
          errors.push(caseLogicMsg('Question could not be found', node.id, { checkKey }));
        } else if (!check.confidence) {
          errors.push(caseLogicMsg('You need to set confidence', node.id, { checkKey }));
        }
      }
    });
  });

  // Effect nodes
  nodeInfo.effectNodes.forEach((node) => {
    const effect = get(node, 'data.effect');
    if (!effect) {
      return;
    }
    if (effect.type === 'AI_ANSWER') {
      if (!effect.id) {
        errors.push(caseLogicMsg('You need to select a question', node.id, { errorId: 'missingQuestion' }));
        return;
      }
      if (!questionsById[effect.id]) {
        errors.push(caseLogicMsg('Question could not be found', node.id, { errorId: 'invalidQuestion' }));
        return;
      }
      if (!effect.reason) {
        errors.push(caseLogicMsg('Provide AI with reason for response', node.id, { errorId: 'missingReason' }));
        return;
      }
    }
    if (effect.type === 'AI_UNSOLICITED_DIALOGUE') {
      const unsolicited = unsolicitedById[effect.id];
      if (!unsolicited) {
        errors.push(caseLogicMsg('Unsolicited item could not be found', node.id));
        return;
      }
      if (!unsolicited.options.answer || !unsolicited.options.answer.en) {
        errors.push(dialogueMsg('Empty unsolicited item', unsolicited.id, { errorId: 'emptyUnsolicited' }));
        return;
      }
    }
    if (effect.type === 'AI_UPDATE_PROMPT') {
      if (!effect.reason) {
        errors.push(caseLogicMsg('Provide AI with reason for response', node.id));
        return;
      }
    }
  });

  return {
    errors,
    warnings,
  };
}

export default validateAiNodes;